// Dependencies
import styled, { css } from "styled-components";

// Utils
import { theme } from "config/theme";

type ContainerStyleProps = {
    containerSize: "regular" | "large";
};

export const Container = styled.div<ContainerStyleProps>`
    display: inline-block;

    .badge-container {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${theme.colors.brand[300]};
        min-width: 1em;
        min-height: 1em;
        border-radius: 0.5em;
        padding: 0px 0.25em;
        font-size: 1rem;

        ${({ containerSize }) =>
            containerSize === "large" &&
            css`
                padding: 0.25em 0.5em;
                border-radius: 1em;
            `}
    }

    .badge-content {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-size: 0.75rem;
        font-weight: 700;
        text-transform: uppercase;
        color: ${theme.colors.white};

        letter-spacing: 0;
        line-height: 1.333;
    }
`;
